// extracted by mini-css-extract-plugin
module.exports = {"errorText":"style_errorText__KihE9","successText":"style_successText__Zj7xI"};